import { render, staticRenderFns } from "./SeatConfig.vue?vue&type=template&id=2aff3572&scoped=true"
import script from "./SeatConfig.vue?vue&type=script&lang=js"
export * from "./SeatConfig.vue?vue&type=script&lang=js"
import style0 from "./SeatConfig.vue?vue&type=style&index=0&id=2aff3572&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aff3572",
  null
  
)

export default component.exports